import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import UserList from '../../components/manager/UserList'
import { useLocation } from 'react-router-dom'

const Users = () => {
  return (
    <AdminLayout>
      <AdminContentLayout children={<UserList />} />
    </AdminLayout>
  )
}

export default Users
